import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './styles/index.css';
import { setupAreas } from './areas';
import { queryClient } from './lib/queryClient';
import { App } from './App';

// Every product area registers its views, slots and commands before the first render.
setupAreas();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
